import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import { useState } from 'react';
import Main from './components/Main';
import Footer from './components/Footer';

function App() {


  const [sva, setSva] = useState({
    country: "FR",
    img: "",
    name: "",
    width: "",
    tel: ""
  });

  return (
    <HelmetProvider>
      <Header sva={sva} setSva={setSva} />
      <Main sva={sva} />
      <Footer />
    </HelmetProvider>
  );
}

export default App;
